import type { IconData } from '@stacksjs/iconify-core'

export const linkH: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10 17H7A5 5 0 0 1 7 7h3a1 1 0 0 1 0 2H7a3 3 0 0 0 0 6h3a1 1 0 0 1 0 2m7 0h-3a1 1 0 0 1 0-2h3a3 3 0 0 0 0-6h-3a1 1 0 0 1 0-2h3a5 5 0 0 1 0 10\"/><path fill=\"currentColor\" d=\"M15 13H9a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default linkH
